import Logo from "../../assets/images/BX-LOGO.svg";
import {useLocation} from "react-router-dom";
import {Button} from "reactstrap";
import {useMutation} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {resendVerificationEmail} from "../../api/api";
import Loader from "../../components/Loader";


function VerificationEmailSentPage() {
    const location = useLocation();
    const { email } = location.state || {};

    const resendMutation = useMutation({
        mutationFn: resendVerificationEmail,
        onSuccess: () => {
            toast.success('Verification email sent!')
        },
        onError: err => {
            toast.error(`An error occurred! ${err?.response?.data?.detail || ''}`)
        }
    })

    const handleResend = () => {
        const formData = new FormData();
        formData.append("email", email);
        resendMutation.mutate(formData)
    };

    return (
        <>
            <div className="account-pages mt-5 mb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="card">

                                <div className="card-body p-4">

                                    <div className="text-center w-75 m-auto">
                                        <span>
                                            <img
                                                src={Logo}
                                                width="73"
                                                height="56"
                                                alt={Logo}/>
                                        </span>
                                    </div>

                                    <div className="mt-3 text-center">

                                        <h3>Verification Email Sent !</h3>
                                        <p className="text-muted mt-2"> We've sent an email to <span
                                            className="font-weight-medium">{email} </span>
                                             to verify your email address. The link in the email will expire in 5 minutes.
                                             </p>

                                        <Button
                                            className="btn btn-block bx-btn-primary waves-effect waves-light mt-3"
                                            onClick={handleResend}
                                            disabled={resendMutation.isLoading || !email}
                                        >
                                            {resendMutation.isLoading? <><Loader size={'small'}/>Resending...</>: `Resend Verification Email`}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default VerificationEmailSentPage;
